var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.languages,"item-text":"name","item-value":"locale","label":_vm.$t('SETTINGS.APPLICATION_LANGUAGE'),"hint":_vm.$t('SETTINGS.APPLICATION_LANGUAGE'),"persistent-hint":"","solo":""},model:{value:(_vm.appLanguage),callback:function ($$v) {_vm.appLanguage=$$v},expression:"appLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }